import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from './base/service.base';
import {
  DocumentType,
  MetadataExtractionTemplate,
  MetadataExtractionTemplateFieldMapping,
  TmfPublishing,
} from '@app/origami-api/utils/topic-utils';
import { Observable } from 'rxjs';

export namespace DocumentTypeServiceOptions {
  export interface GetDocumentTypesOptions {
    siteId: number;
    categoryTopicId?: number;
    categoryId?: number;
    docTypeIds?: number[];
    includeFieldsInResult?: boolean;
    relatedFolderIds?: number[];
    parentId?: number;
    searchClause?: string;
    includeSelf?: boolean;
    includeChildren?: boolean;
    searchQuery?: string;
    viewMode?: number;
    filterValue?: string;
    searchAllLevels?: boolean;
    withoutChildsOnly?: boolean;
    fieldListing?: string[];
    tmfPublishing?: TmfPublishing;
  }

  export interface GetSuggestedDocumentTypesOptions {
    siteId: number;
    topicId: number;
    tmfPublishing?: TmfPublishing;
  }

  export interface AddKofaxTemplateOptions {
    siteId: number;
    documentTypeId: number;
    templateName: string;
    fileToken: string;
  }

  export interface DeleteKofaxTemplateOptions {
    siteId: number;
    templateId: number;
  }

  export interface GetKofaxTemplatesOptions {
    siteId: number;
    templateId: number;
    documentTypeId: number;
  }

  export interface UpdateKofaxFieldsMappingOptions {
    siteId: number;
    templateId: number;
    kofaxFieldsMapping: MetadataExtractionTemplateFieldMapping[];
  }
}

export interface SuggestedDocumentType {
  DocumentCategory: string;
  DocumentCategoryId: number;
  DocumentTypeFullName: string;
  DocumentTypeId: number;
  DocumentTypeName: string;
  Score: number;
}

/*
  Let's use this request to retrieve a single document type. Please replace "null" with a real values.
  This is done to hit the cache and to avoid repeating API requests
 */
// export const SINGLE_DOCTYPE_REQUEST_BASE = {
//   siteId: null,
//   fieldListing: [
//     FieldNames.DocumentType.FolderId,
//     FieldNames.DocumentType.Hierarchy,
//     FieldNames.Document.EffectiveImmediately,
//     FieldNames.Document.EffectivePeriod,
//     FieldNames.Document.PeriodicReviewNotRequired,
//     FieldNames.Document.NextReviewPeriod,
//     FieldNames.DocumentType.IncludeInChangeControlWorkflow,
//     FieldNames.Document.ResponsibleDepartmentId,
//     FieldNames.Document.ResponsiblePartyTypeId,
//     FieldNames.DocumentType.CWSMatchingDocumentTypeId,
//     FieldNames.DocumentType.Instructions,
//     FieldNames.DocumentType.Description,
//     FieldNames.Document.CodingTypeName
//   ],
//   includeFieldsInResult: true,
//   docTypeIds: [ null ],
//   tmfPublishing: {
//     RetrieveFromTmf: null
//   }
// };

@Injectable()
export class DocumentTypeService extends ServiceBase {
  serviceUrl = 'DocumentTypeService.svc';

  getDocumentTypes(
    body: DocumentTypeServiceOptions.GetDocumentTypesOptions,
    ...params
  ): Observable<OrigamiResponse<DocumentType[]>> {
    const p: any = Object.assign({}, body);

    p.relatedFolderIds = body.relatedFolderIds ? body.relatedFolderIds.join(',') : null;
    p.fieldListing = body.fieldListing ? body.fieldListing.join(',') : null;

    return this.origamiPost('/GetDocumentTypes', p, ...params);
  }

  getSuggestedDocumentTypes(
    body: DocumentTypeServiceOptions.GetSuggestedDocumentTypesOptions,
  ): Observable<OrigamiResponse<SuggestedDocumentType[]>> {
    return this.origamiPost('/GetSuggestedDocumentTypes', body, null, null, true);
  }

  addKofaxTemplate(
    body: DocumentTypeServiceOptions.AddKofaxTemplateOptions,
  ): Observable<OrigamiResponse<MetadataExtractionTemplate>> {
    return this.origamiPost('/addKofaxTemplateOptions', body, null, null, true);
  }

  deleteKofaxTemplate(
    body: DocumentTypeServiceOptions.DeleteKofaxTemplateOptions,
  ): Observable<OrigamiResponse<boolean>> {
    return this.origamiPost('/DeleteKofaxTemplate', body, null, null, true);
  }

  updateKofaxFieldsMapping(
    body: DocumentTypeServiceOptions.UpdateKofaxFieldsMappingOptions,
  ): Observable<OrigamiResponse<MetadataExtractionTemplateFieldMapping[]>> {
    return this.origamiPost('/UpdateKofaxFieldsMapping', body, null, null, true);
  }

  getKofaxTemplates(
    body: DocumentTypeServiceOptions.GetKofaxTemplatesOptions,
  ): Observable<OrigamiResponse<MetadataExtractionTemplate[]>> {
    return this.origamiPost('/GetKofaxTemplates', body, null, null, true);
  }
}
